import React, {useState} from 'react'

import './roomsavailable.css'
import RoomCard from './RoomCard/RoomCard.js'
import BookingConfirmation from './BookingConfirmation/BookingConfirmation.js'
import RoomsUnavailable from './RoomsUnavailable/RoomsUnavailable.js'

import { ArrowLeftOutlined } from '@ant-design/icons';

const dayjs = require('dayjs')

const RoomsAvailable = ({values, setSearching, roomsInfo}) => {
	const [bookingScreen, setBookingScreen] = useState(false)
	const [roomBookedId, setRoomBookedId] = useState({id: null, name: null})
	const backToSearcher = () => {
		setSearching(true) 
	}
	
	const backToRoomsAvailable = () => {
		setBookingScreen(false)
	}
	
	return (
		!bookingScreen ?
		<div className="wrapperroomsavailable">
			<div className="backbtn" onClick={backToSearcher}>
				<ArrowLeftOutlined />
			</div>
			<div className="infoBooking">
				<p>DISPONIBLES PARA LA FECHA:</p>
				<span>{dayjs(values.date).format('DD/MM/YY') + ' de ' + dayjs(values.time[0]).format('HH:mm') + ' a ' + dayjs(values.time[1]).format('HH:mm')}</span>
			</div>
			<div>
			{
				roomsInfo.length 
					? roomsInfo.map(item => {
							return <RoomCard key={item.id} title={item.title} title2={item.title2} image={item.image} setBookingScreen={setBookingScreen} color={item.color} ammenities={item.ammenities} id={item.id} setRoomBookedId={setRoomBookedId}/>
					  })
				:
				<RoomsUnavailable />
			}
			</div>
		</div>
		:
		<BookingConfirmation handleBack={backToRoomsAvailable} values={values} roomBookedId={roomBookedId} setSearching={setSearching}/>
	)
}

export default RoomsAvailable